<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-center align-items-center">
        <header class="header">
          <img class="header-logo" src="assets/images/logo/logo.svg" alt="" />
        </header>
      </div>
      <div class="section-auth-container login-card">
        <div>
          <div class="login-main">
            <form
              class="theme-form"
              ngNativeValidate
              [formGroup]="forgotPasswordForm"
            >
              <div class="form-group">
                <label class="col-form-label">{{
                  "forms.email" | translate
                }}</label>
                <div class="form-input position-relative">
                  <input
                    class="form-control"
                    type="email"
                    formControlName="email"
                  />
                  @if (forgotPasswordForm.controls['email'].touched &&
                  forgotPasswordForm.controls['email'].errors?.['required']) {
                  <div class="text text-danger mt-1">
                    {{ "forms.error_mandatory_field" | translate }}
                  </div>
                  } @if (forgotPasswordForm.controls['email'].touched &&
                  forgotPasswordForm.controls['email'].errors?.['email']) {
                  <div class="text text-danger mt-1">
                    {{ "forms.invalid_email" | translate }}
                  </div>
                  }
                </div>
              </div>
              <div class="text-start mt-3 mb-3">
                <button
                  class="btn btn-primary btn-block sweet-2"
                  type="submit"
                  (click)="sendEmail()"
                >
                  {{ "forms.reset_password" | translate }}
                </button>
              </div>
              <a class="pull-left mt-2 link" [routerLink]="['/auth/login']">
                {{ "button_labels.login" | translate }}</a
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer class="footer footer-fix">
  <app-footer></app-footer>
</footer>
